import { granularity, height, rotation, stRotation, extrudedHeight } from '../mixinProps'
/**
 * vc-graphics-rectangle base props mixins
 */
export default {
  mixins: [granularity, height, rotation, stRotation, extrudedHeight]
}
